import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { MDSIconButton } from "@/mds/components/buttons";

export const StyledActionIconContainer = styled.div`
  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.grey.x400};
  }
`;

export const StyledActionSendContainer = styled.div<{ isActive?: boolean }>`
  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme, isActive }) => getIconColor(theme, isActive)};
  }
`;

export const StyledButton = styled(MDSIconButton)`
  padding: ${({ theme }) => theme.spacing.sm};
`;

const getIconColor = (theme: Theme, isActive?: boolean) => {
  if (!isActive) {
    return theme.colors.grey.x400;
  }

  return theme.colors.mblue.x600;
};
